// Libraries
window._ = require('lodash');
window.moment = require('moment-timezone');
try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

// Vue
window.Vue = require('vue')
Vue.prototype.$moment = window.moment

window.eventBus = new Vue()

// Application
Vue.component('application-form', require('@/components/FunnelSources/Application/Application').default)
Vue.component('application-navbar', require('@/components/FunnelSources/Application/ApplicationNavbar').default)
// Registration
Vue.component('registration-form', require('@/components/FunnelSources/Application/Registration').default)
Vue.component('registration-navbar', require('@/components/FunnelSources/Application/RegistrationNavbar').default)
Vue.component('processing-payment-modal', require('@/components/FunnelSources/ProcessingPaymentModal').default)

window.appicationFunnel = new Vue({
    name: "Application Funnel",
    el: "#application-funnel",

    methods: {
        google() {
            eventBus.$emit('google-api-ready')
        }
    }
})
